/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <span className="flex flex-col h-screen bg-gray-800 text-white">
      {/* <Header siteTitle={data.site.siteMetadata.title} /> */}
      <div className="container m-auto flex-1">
        <main>{children}</main>
      </div>
      <Footer />
    </span>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
